module.exports = __webpack_public_path__ + "static/media/smash.3c63d8d8.svg";